import React from 'react'
import OfficeHoursReceptionDeskForm from './OfficeHoursReceptionDeskForm'
import OfficeHoursOtherForm from './OfficeHoursOtherForm'
import { isSuccessful } from '../../../hooks/useQuery'
import { useAuth } from '../../molecules/Auth'
import useOfficeHour from '../../../hooks/services/useOfficeHour'

const OfficeHoursForm = () => {
  const { user } = useAuth()
  const { getOfficeHour, updateOfficeHour, invalidateOfficeHour } = useOfficeHour(user.institution_id)
  const { data: officeHour, status } = getOfficeHour()

  const handleSave = async values => {
    await updateOfficeHour(
      { ...values, id: user.institution_id },
      {
        onSuccess: () => {
          invalidateOfficeHour()
        }
      }
    )
  }

  if (!isSuccessful(status)) return null

  return (
    <div className="flex flex-col gap-4 mb-16">
      <OfficeHoursReceptionDeskForm initialValues={officeHour} onSubmit={handleSave} />
      <OfficeHoursOtherForm initialValues={officeHour} onSubmit={handleSave} />
    </div>
  )
}

export default OfficeHoursForm
